/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { AccountsDirectory } from "./AccountsDirectory";
import { CARE_TEAM_ROLES } from "../api/accounts";
import { useChrome } from "../contexts/ChromeContext";

export function CareTeam() {
  useChrome({}, []);
  return (
    <div className="space-y-8">
      <header className="enter">
        <h1 className="font-display text-2xl leading-tight text-text-primary sm:text-[1.75rem]">
          Care team
        </h1>
        <p className="mt-2 text-[15px] leading-relaxed text-text-secondary">
          The coordinators, therapists, coaches and billing specialists a family&apos;s care team
          can include. Open one to see the families they are on, cover every active family, or
          change who can message them.
        </p>
      </header>
      <AccountsDirectory
        scope="care_team"
        roleOptions={[...CARE_TEAM_ROLES]}
        searchPlaceholder="Search the care team by name, email, phone, or id"
      />
    </div>
  );
}
